import { importacionOperacionesApi } from "../importacion-operaciones/importacionOperacionesApi";

const API_ROOT = (process.env.REACT_APP_API_URL || "").replace(/\/$/, "");
const PAGOS_API_BASE = `${API_ROOT}/api/pagos`;

// Campos del preview payment-engine que necesitan los controles previos. Se envía sólo este
// subconjunto: el control no recalcula importes de la corrida.
const SNAPSHOT_FIELDS = [
  "fiservOperationId", "terminalFiserv", "merchantId", "matchStatus", "resolutionStatus",
  "paymentEligibility", "scheduleType", "requiresCommercialExceptionRule", "paymentAmountStatus", "grossAmount",
];

export const toRunSnapshot = (rows = []) => rows.map((row) => Object.fromEntries(
  SNAPSHOT_FIELDS.map((field) => [field, row[field] ?? null]),
));

const buildForm = ({ fur, txt, runId, runRows, pagosManuales }) => {
  const formData = new FormData();
  formData.append("fur", fur);
  if (txt) formData.append("txt", txt);
  if (runId && runRows) {
    formData.append("runId", runId);
    formData.append("operacionesCorrida", JSON.stringify(toRunSnapshot(runRows)));
  }
  formData.append("pagosManuales", JSON.stringify(pagosManuales || []));
  return formData;
};

const buildProcesamientoForm = ({ importacionId, runId, txt, pagosManuales }) => {
  const formData = new FormData();
  formData.append("importacionId", importacionId);
  if (runId) formData.append("runId", runId);
  if (txt) formData.append("txt", txt);
  formData.append("pagosManuales", JSON.stringify(pagosManuales || []));
  return formData;
};

const request = (path, token, options = {}) => importacionOperacionesApi.request(`${PAGOS_API_BASE}${path}`, {
  cache: "no-store",
  ...options,
  headers: { ...importacionOperacionesApi.buildHeaders(token), ...(options.headers || {}) },
});

export const pagosApi = {
  async analizarControlesPrevios(payload, token) {
    return request("/controles-previos/analizar", token, { method: "POST", body: buildForm(payload) });
  },

  // Liquidaciones persistidas: sólo responden en el entorno de desarrollo aislado.
  async estadoLiquidaciones(token) {
    return request("/liquidaciones/estado", token);
  },

  async registrarLiquidacion({ fechaPago, ...payload }, token) {
    const formData = buildForm(payload);
    formData.append("fechaPago", fechaPago);
    return request("/liquidaciones", token, { method: "POST", body: formData });
  },

  async obtenerPendientes(token) {
    return request("/liquidaciones/obligaciones/pendientes?canal=SAS", token);
  },

  // Procesamiento SAS: lote = importación de Importación Ops + corrida de Conciliación Ops.
  async lotesSas(fecha, token) {
    return request(`/procesamiento/lotes?fecha=${encodeURIComponent(fecha)}`, token);
  },

  async procesarSas(payload, token) {
    return request("/procesamiento/controles", token, { method: "POST", body: buildProcesamientoForm(payload) });
  },

  async registrarProcesamiento(payload, token) {
    return request("/procesamiento/registrar", token, { method: "POST", body: buildProcesamientoForm(payload) });
  },

  async informarPagoManual(obligacionId, body, token) {
    return request(`/liquidaciones/obligaciones/${obligacionId}/pagos-manuales`, token, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    });
  },
};
